import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Asset, User } from '../../../contexts/AuthContext';

interface MobileHeaderProps {
  onMenuClick: () => void;
  currentAsset: Asset | null;
  assets: Asset[];
  user: User | null;
  onAssetChange: (asset: Asset) => void;
  onLogout: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  onMenuClick,
  currentAsset,
  assets,
  user,
  onAssetChange,
  onLogout,
}) => {
  const [isAssetDropdownOpen, setIsAssetDropdownOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleAssetSelect = (asset: Asset) => {
    onAssetChange(asset);
    setIsAssetDropdownOpen(false);
  };

  return (
    <header className="mobile-header">
      <div className="mobile-header-left">
        <button className="btn-hamburger" onClick={onMenuClick} aria-label="Open menu">
          <i className="bi bi-list"></i>
        </button>
      </div>

      <div className="mobile-header-center">
        <div className="mobile-logo">
          <div
            className="mobile-logo-icon"
            style={{ background: 'linear-gradient(135deg, #4F46E5, #7C3AED)', flexShrink: 0 }}
          >
            <span style={{ color: '#fff', fontSize: 18, fontWeight: 700, lineHeight: 1 }}>C</span>
          </div>
          <span className="mobile-logo-text">CloudAyn</span>
        </div>
      </div>

      <div className="mobile-header-right">
        {/* Asset Selector */}
        <button
          className="btn-mobile-asset"
          onClick={() => setIsAssetDropdownOpen(!isAssetDropdownOpen)}
          aria-label="Select asset"
        >
          <i className="bi bi-box-seam"></i>
        </button>

        {/* User Avatar */}
        <div
          className="mobile-user-avatar"
          onClick={() => setIsUserDropdownOpen(!isUserDropdownOpen)}
        >
          {user?.name.charAt(0).toUpperCase()}
        </div>
      </div>

      {/* Asset Dropdown */}
      {isAssetDropdownOpen && (
        <>
          <div
            className="mobile-dropdown-backdrop"
            onClick={() => setIsAssetDropdownOpen(false)}
          />
          <div className="mobile-dropdown-menu">
            <div className="mobile-dropdown-header">
              <h6 className="mb-0 fw-semibold">Select Asset</h6>
            </div>
            {assets.map((asset) => (
              <button
                key={asset.id}
                className={`mobile-dropdown-item ${currentAsset?.id === asset.id ? 'active' : ''}`}
                onClick={() => handleAssetSelect(asset)}
              >
                <i className="bi bi-box-seam"></i>
                <div>
                  <div className="fw-medium">{asset.name}</div>
                  <small className="text-muted">{asset.tracking_id}</small>
                </div>
              </button>
            ))}
            <div className="mobile-dropdown-divider" />
            <button
              className="mobile-dropdown-item"
              onClick={() => {
                setIsAssetDropdownOpen(false);
                navigate('/assets');
              }}
            >
              <i className="bi bi-plus-circle"></i>
              <span>Manage Assets</span>
            </button>
          </div>
        </>
      )}

      {/* User Dropdown */}
      {isUserDropdownOpen && (
        <>
          <div
            className="mobile-dropdown-backdrop"
            onClick={() => setIsUserDropdownOpen(false)}
          />
          <div className="mobile-dropdown-menu">
            <div className="mobile-dropdown-header">
              <div className="fw-semibold">{user?.name}</div>
              <small className="text-muted">{user?.email}</small>
            </div>
            <button
              className="mobile-dropdown-item"
              onClick={() => {
                setIsUserDropdownOpen(false);
                navigate('/organisation');
              }}
            >
              <i className="bi bi-building"></i>
              <span>My Organisation</span>
            </button>
            <button
              className="mobile-dropdown-item"
              onClick={() => {
                setIsUserDropdownOpen(false);
                navigate('/users');
              }}
            >
              <i className="bi bi-people"></i>
              <span>Users</span>
            </button>
            <div className="mobile-dropdown-divider" />
            <button
              className="mobile-dropdown-item danger"
              onClick={() => {
                setIsUserDropdownOpen(false);
                onLogout();
              }}
            >
              <i className="bi bi-box-arrow-right"></i>
              <span>Logout</span>
            </button>
          </div>
        </>
      )}
    </header>
  );
};

export default MobileHeader;
